import api from '../../../configs/instanceApi';

export const getAllBanks = (haveOnlyPsrMigratedSelected) => {
  const urlIsMigrated = haveOnlyPsrMigratedSelected
    ? ''
    : `&isMigrated=${haveOnlyPsrMigratedSelected}`;
  const url = `/accreditation-quotations/banks?page=0&size=1000&sort=id-asc${urlIsMigrated}`;
  return api.get(url);
};

export const getAccountTypes = () => {
  const url = `/accreditation-quotations/banks/account-types`;
  return api.get(url);
};

export const sendBank = (ecIdentity, bank, recaptchaToken = '') => {
  const url = `/accreditation-quotations/quotations/${ecIdentity}/bank`;
  const config = {
    headers: {}
  };

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  return api.patch(url, bank, config);
};
